// extracted by mini-css-extract-plugin
module.exports = {"Form":"Inputs_Form__1sfzi","select":"Inputs_select__3eZCE","dismiss":"Inputs_dismiss__2f_uI"};